export default "__VITE_ASSET__CU8nqQ4u__"